// requestIdleCallback polyfill for older browsers
if (!window.requestIdleCallback) {
  window.requestIdleCallback = function (cb, options) {
    const start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function () {
          return Math.max(0, 50 - (Date.now() - start));
        },
      });
    }, 1);
  };
  window.cancelIdleCallback = function (id) {
    clearTimeout(id);
  };
}

// Only load critical bootstrap components
require("bootstrap/js/transition");
require("bootstrap/js/collapse");
require("bootstrap/js/dropdown");
require("bootstrap/js/modal");

// Lazy load non-critical libraries
require("lazyload");

// Load jquery-easing for smooth scrolling
require("jquery-easing");

// Make shared libs available globally so page bundles don't re-import them
// window.Flickity = require("flickity"); // Moved to on-demand loading
// require("imagesloaded"); // Moved to on-demand loading
// require("unidragger"); // Moved to on-demand loading

/**
 * Cookies Settings
 */
global.Cookies = require("js-cookie");

/**
 * Lazyload for images
 */
let images = document.querySelectorAll("img.lazy");
lazyload(images);

/**
 * Ajax with Laravel CSRF token
 */
const _token = $('meta[name="csrf-token"]').attr("content");
$.ajaxSetup({
  headers: {
    "X-CSRF-TOKEN": _token,
  },
});
